var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "accordion-item",
      class: {
        disabled: _vm.disabled,
      },
      style: {
        borderColor: _vm.$themeTokens.fineLine + "!important",
      },
    },
    [
      _c("h3", { staticClass: "header-wrapper" }, [
        _c(
          "button",
          {
            staticClass: "header",
            style: _vm.headerAppearanceOverrides,
            attrs: {
              "aria-expanded": _vm.isExpanded,
              "aria-controls": _vm.contentId,
              disabled: _vm.disabled,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.toggle.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "header-content" }, [
              _c("div", { staticClass: "title-actions-wrapper" }, [
                _vm.$slots["leading-actions"]
                  ? _c(
                      "div",
                      { staticClass: "leading-actions" },
                      [_vm._t("leading-actions")],
                      2
                    )
                  : _vm._e(),
                _c(
                  "span",
                  {
                    style: {
                      color: _vm.disabledTitle
                        ? _vm.$themeTokens.textDisabled
                        : "inherit",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.title) + "\n          "
                    ),
                  ]
                ),
              ]),
              _c(
                "div",
                { staticClass: "trailing-actions" },
                [
                  _vm._t("trailing-actions"),
                  _c("KIconButton", {
                    attrs: {
                      tabindex: "-1",
                      icon: _vm.isExpanded ? "chevronDown" : "chevronRight",
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggle.apply(null, arguments)
                      },
                    },
                  }),
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
      _vm.isExpanded
        ? _c(
            "div",
            {
              staticClass: "content",
              style: _vm.contentAppearanceOverrides,
              attrs: { id: _vm.contentId },
            },
            [_vm._t("content")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }